export default "__VITE_ASSET__DQpNGA6V__"